var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"header":_vm.titulo}},[_c('b-table',{staticClass:"datos-objeto",attrs:{"small":"","responsive":"sm","items":_vm.datos,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(valor)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm.formattedData(data.item))+"\n      ")]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }